/**
 * MY 메모 시트 (일지 카드 > MY 메모)
 *
 * 구 Diary/Main.js 의 전역 add_workMemos / add_workMemos_Start / savememo / deleterequest 이관.
 *
 * ⚠ 구현은 스캐폴드의 공용 팝업 상자(#memoinputmore)에 HTML 을 넣고 그 '노드째' BS 안으로
 *   옮겼다가 닫을 때 되돌리는 방식이었다. 원위치를 호출 시점의 부모로 잡는 바람에 시트가
 *   열린 상태에서 다시 열면 노드가 시트 안으로 '복귀'해 그대로 사라졌다.
 *   지금은 자기 마크업을 BS content-area 에 직접 그린다 — 옮길 노드가 없다.
 *
 * [호출]
 *   $j.F.Diary.WorkMemo.open(ordernum)     // window.add_workMemos 브리지가 이걸 부른다
 */
import Util from '../../Common/Util';

export default class WorkMemo {
    open(ordernum) {
        $j.Ui.BS.open({
            target: '$j.F.Diary.WorkMemo',
            fixedHeight: true,
            data: { ordernum },
        });
        $j.Ui.BS.setTitle('MY 메모');
    }

    init() {
        this.ordernum = this.data.ordernum;
        this.$el = $(`#${this.id}`);
        this.$el.html(`<div class="wmemo"><div class="wmemo__empty">${$j.Common.Util.spinnerHtml('jb-spin--fade')}</div></div>`);
        this.initHandler();
        this.load();
    }

    destroy() {
        this.$el?.off();
    }

    /** 인라인 onclick 대신 위임 — 마크업이 이 모듈 소유라 전역 함수를 만들 이유가 없다. */
    initHandler() {
        this.$el
            .on('click', '[data-act="close"]',   () => $j.Ui.BS.close())
            .on('click', '[data-act="save"]',    (e) => this.save(e, 0))
            .on('click', '[data-act="saveEnd"]', (e) => this.save(e, 1))
            .on('click', '[data-act="del"]', (e) => {
                const $b = $(e.currentTarget);
                this.remove($b.data('num'), $b.data('mine') === 1 || $b.data('mine') === true);
            });
    }

    load() {
        $.ajax({
            type: 'get',
            url: `/m/ajax/order/${this.ordernum}/mymemos`,
            data: { ordernum: this.ordernum },
            dataType: 'json',
        }).done((rows) => {
            this.draw(rows || []);
            this.$el.find("#my-memo").trigger("focus");
        });
    }

    draw(rows) {
        const list = rows.map((row, idx) => {
            const isMine = row['mb_no'] == MEMBER['num'];
            return `
                <div class="wmemo__item" id="${this.ordernum}_${idx}memo">
                    ${Util.escapeHtml(row['memo']).replace(/&lt;\/?br\s*\/?&gt;/gi, '<br>')}
                    <div class="wmemo__meta">
                        <span>${Util.escapeHtml(row['mem_name'])}</span>
                        <span>${Util.getSimpleDateTime(row['datetime'])}</span>
                        <button type="button" class="wmemo__del" data-act="del"
                                data-num="${row['num']}" data-mine="${isMine ? 1 : 0}">삭제</button>
                    </div>
                </div>`;
        }).join('');

        // 제목은 BS 헤더가 들고 있다 (구 마크업의 'My 메모 작성하기' 줄 제거)
        this.$el.html(`
<div class="wmemo" id="memoboxIn">
    <div class="wmemo__list">
        ${list || '<div class="wmemo__empty">등록된 메모가 없습니다.</div>'}
    </div>
    <textarea class="wmemo__input" id="my-memo" placeholder="나만 볼 수 있는 메모로 현장 상황 등을 적어두세요"></textarea>
    <div class="dsheet__foot">
        <button type="button" class="dsheet__btn" data-act="close">닫기</button>
        <button type="button" class="dsheet__btn" data-act="save">등록</button>
        <button type="button" class="dsheet__btn dsheet__btn--ok" data-act="saveEnd">등록 후 닫기</button>
    </div>
</div>`);
    }

    /**
     * @param actn 0=등록(시트 유지) 1=등록 후 닫기
     */
    save(evt, actn) {
        if (evt) { evt.preventDefault(); evt.stopPropagation(); }

        const memo = this.$el.find('#my-memo').val() || '';
        if (!this.ordernum)  { Util.swalert('오더정보가 없습니다', ''); return; }
        if (memo.length < 1) { Util.swalert('저장할 메모를 입력해 주세요', ''); return; }

        if (actn == 1) $j.Ui.BS.close();
        this.$el.find('.wmemo__list').html(`<div class="wmemo__empty">${$j.Common.Util.spinnerHtml('jb-spin--fade')}</div>`);

        $.ajax({
            type: 'POST',
            url: `/m/ajax/order/${this.ordernum}/mymemos`,
            data: { ordernum: this.ordernum, memo_text: memo },
        }).done(() => {
            // 등록만 한 경우엔 카드 갱신 후에도 이 시트를 유지한다(keepPopupTop1)
            showDetailTable(window.lastOpen_Tab_order, window.lastOpen_Tab_tab, window.lastOpen_Tab_act,
                actn == 1 ? '' : 'keepPopupTop1', 'ForceToTab');
            if (actn != 1) this.load();
        });
    }

    remove(num, isMine) {
        if (!isMine) { Util.swalert('타인이 작성한 메모는 삭제할수 없습니다.'); return; }

        Util.swalert(['해당 메모를 삭제 할까요?', 'question'], () => {
            $.ajax({
                type: 'delete',
                url: `/m/ajax/order/${this.ordernum}/mymemos`,
                data: { ordernum: this.ordernum, delnum: num },
                dataType: 'json',
            }).done(() => {
                showDetailTable(window.lastOpen_Tab_order, window.lastOpen_Tab_tab, window.lastOpen_Tab_act,
                    'keepPopupTop1', 'ForceToTab');
                this.load();
            });
        }, ['확인', '아니오']);
    }
}
